module.exports = __webpack_public_path__ + "static/img/11.c770688.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/11.png
// module id = Zmbf
// module chunks = 0